import { green } from '@mui/material/colors';

export const confirmSubmitModalStyles = {
	actionsRow: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 1,
		width: '100%'
	},

	changeRow: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'baseline',
		columnGap: 1,
		rowGap: 0.25
	},

	valueColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		minWidth: 0
	},

	previousValue: {
		fontSize: '0.875rem',
		textDecoration: 'line-through',
		color: 'text.secondary'
	},

	tag: {
		display: 'inline-block',
		flexShrink: 0,
		fontSize: '0.75rem',
		fontWeight: 400
	},

	wholeItemsGrid: {
		display: 'grid',
		gridTemplateColumns: 'max-content 1fr',
		alignItems: 'baseline',
		columnGap: 1,
		rowGap: 1
	},

	gridContents: {
		display: 'contents'
	},

	addedTag: {
		color: green[600]
	},

	removedTag: {
		color: 'error.light'
	},

	arrowIcon: {
		fontSize: '1.125rem',
		color: 'text.secondary',
		alignSelf: 'center'
	},

	newValue: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'text.primary'
	},

	removedValue: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'text.disabled'
	},

	wholeEntityChip: {
		alignSelf: 'flex-start'
	},

	wholeEntityChipRow: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: 0.5
	}
};
